import { useState, useRef, useEffect } from 'react'

/**
 * Works just like `useState`, but also tracks a `ref` that has the same value as the state. The
 * function takes care of updating the ref when you call setState
 *
 * The purpose of this function is to expose the ref to global event handlers instantiated from
 * within a component (such as `window.addEventListener`) since such functions do not have access to
 * an up-to-date state (the function has a stale scope when called, since it detached from the
 * component lifecycle)
 */
export function useStateRef<T>(initialValue: T) {
  const [value, setValue] = useState(initialValue)

  const ref = useRef(value)

  useEffect(() => {
    ref.current = value
  }, [value])

  return [value, setValue, ref] as [typeof value, typeof setValue, typeof ref]
}
